import api from "./api";

export function fnStoreComent(nActivityId, oData) {
     const response = api.post(`/operational-panel-activity-comment/${nActivityId}`, oData);
     return response;
}
export function fnDeleteComent(nCommentId) {
     const response = api.delete(`/operational-panel-activity-comment/${nCommentId}`);
     return response;
}

export function fnUpdateComent(nCommentId, oData) {
     const response = api.patch(`/operational-panel-activity-comment/${nCommentId}`, oData);
     return response;
}

export function fnListComments(nActivityId) {
     const response = api.get(`/operational-panel/${nActivityId}/comment`)
     return response;
}